import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Client } from "../../api-client/api-client";
import { API_GET_FILES_BY_CATEGORY, API_GET_FILES_CATEGORIES, API_POLL_STATUS_FILE_ADMIN, API_VALIDATE_FILE } from "../../route/api.routes";
const config = {
  name: "files",
};
export const getFilesCategories: any = createAsyncThunk(
  `${config.name}/getFilesCategories`,
  async (data: any) => {
    return await Client.get(API_GET_FILES_CATEGORIES);
  }
);
export const getFilesByCategory: any = createAsyncThunk(
  `${config.name}/getFilesByCategory`,
  async ({category_id, params}: any) => {
    delete params.total
    return await Client.get(API_GET_FILES_BY_CATEGORY(category_id), {params});
  }
);
export const validateFile: any = createAsyncThunk(
  `${config.name}/validateFile`,
  async (body: any) => {
    return await Client.post(API_VALIDATE_FILE, body);
  }
);
export const pollStatusFileAdmin: any = createAsyncThunk(
  `${config.name}/pollStatusFileAdmin`,
  async (params: any) => {
    return await Client.get(API_POLL_STATUS_FILE_ADMIN, {params});
  }
);

export const filesSlice = createSlice({
  name: config.name,
  initialState: {
    loading_files: false,
    files_list: [] as any,
    pagination: { offset: 0, limit: 10, total: 0 },
    error: "" as string,
    filters: null as any,
    sorters: {
      sort_column: "due_date",
      sort_val: null,
    } as any,
  },
  reducers: {
    reset: (state) => {},
  },
  extraReducers(builder) {
    builder
      //  Fetch Tickets
      .addCase(getFilesByCategory.pending, (state) => {
        state.loading_files = true;
        state.error = "";
      })
      .addCase(getFilesByCategory.fulfilled, (state, action) => {
        state.loading_files = false;
        state.files_list = action?.payload?.data?.data?.items;
        state.pagination = {
          offset: action?.payload?.data?.data?.offset,
          limit: action?.payload?.data?.data?.limit,
          total: action?.payload?.data?.data?.total,
        };
      })
      .addCase(getFilesByCategory.rejected, (state) => {
        state.loading_files = false;
        state.error = "";
      })
    
  },
});

export const { reset } = filesSlice.actions;

export default filesSlice.reducer;
